import { Link } from "react-router-dom";
import { FaPaw } from "react-icons/fa";
import Logo from "@/components/Logo";
import { SOCIALS } from "@/lib/site";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-white/10 bg-[#080a12]">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="flex flex-col items-start justify-between gap-8 md:flex-row md:items-center">
          <div>
            <Link to="/" data-testid="footer-logo-link" className="flex items-center gap-2.5">
              <Logo size={36} />
              <span className="font-display text-lg font-extrabold uppercase tracking-tight text-slate-100">
                TheHusko<span className="text-husko-cyan">Biscuit</span>
              </span>
            </Link>
            <p className="mt-3 max-w-xs text-sm text-slate-400">
              Husko's cozy corner — fursuiting, gaming and general fluff.
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-2">
            {SOCIALS.map((s) => {
              const Icon = s.icon;
              return (
                <a
                  key={s.id}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`footer-social-${s.id}`}
                  aria-label={s.name}
                  className="rounded-xl border border-white/10 p-3 text-slate-300 transition-all hover:-translate-y-0.5 hover:border-husko-cyan/50 hover:text-husko-cyan"
                >
                  <Icon size={18} />
                </a>
              );
            })}
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-white/5 pt-6 text-xs text-slate-500 sm:flex-row sm:items-center">
          <p className="flex items-center gap-1.5">
            © {year} TheHuskoBiscuit — stay fluffy
            <FaPaw size={11} className="text-husko-magenta" />
          </p>
          <button
            data-testid="footer-back-to-top"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-400 transition-colors hover:text-husko-cyan"
          >
            Back to the den ↑
          </button>
        </div>
      </div>
    </footer>
  );
}
